import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import _ from 'lodash';
import { NgRecaptcha3Service } from 'ng-recaptcha3';
import { AUTH_INDICATOR } from 'src/app/global/enums/auth-indicator.enum';
import { ContenidoEnum } from 'src/app/global/enums/contenido.enum';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { Paso1 } from 'src/app/global/interfaces/paso-1';
import { DialogResult } from 'src/app/global/models/dialog/dialog-data';
import { RESUME_HIRING_ACTIONS, ResumeHiringDialogResult } from 'src/app/global/models/dialog/resume-hiring-data';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { AuthVMService } from 'src/app/view-model/services/auth-vm.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { GoToPaso3ServiceVM } from 'src/app/view-model/services/go-to-paso3.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
import { TokenSaverService } from 'src/app/view-model/services/token-saver.service';
import { lengthValidator } from 'src/app/view-model/validators/max-length.validator';
import { rutValidator } from 'src/app/view-model/validators/rut.validator';
import { rutEmpresaValidator } from 'src/app/view-model/validators/rutempresa.validator';
import { rutGenericoValidator } from 'src/app/view-model/validators/rutgenerico.validator';
import { serieValidator } from 'src/app/view-model/validators/serie.validator';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthVmProvider extends AuthVMService {

  rut = 0;
  rutControl: number;
  serieControl: string;
  respuestaAuth: GeneralResponse<any>;
  productos: Product[];
  resRegProducto: any;
  isPersonaNatural: boolean;
  idEjecutivo: number;
  // count the clicks
  private clickTimeout = null;

  constructor(
    private recaptcha3: NgRecaptcha3Service,
    private tokenSaverService: TokenSaverService,
    private dialogService: DialogService,
    private marketplaceRedirectService: MarketplaceRedirectService,
    private rutFormatter: RutFormatterService,
    private formBuilder: FormBuilder,
    private stepperService: StepperServiceVM,
    private productoVMService: vmProductosService,
    private productVm: vmProductosService,
    private carroService: CarroComprasService,
    private goToPaso3Service: GoToPaso3ServiceVM,
    private storage: LocalStorageService,
    private router: Router
  ) {
    super();
  }

  // onlyAuthStorage() {

  // }

  /**
   * Handle auth process
   * @param form formGroup created by function "createForm"
   * @returns true if auth process continue to next step
   */
  async auth(form: FormGroup, isMobile: boolean): Promise<GeneralResponse<any>> {
    if (!form.valid) {
      throw new Error('form invalid');
    }
    // let continueToNextStep = false;
    const tokenCaptcha = await this.recaptcha3.getToken();
    const documentControl = form.get('txtSerie');
    const rut = form.get('txtRut').value;
    const rutInformation = this.rutFormatter.getRutFormats(rut);
    const documentNumber = (documentControl.value as string).replace(/\./g, '');
    const dispositivoMobile = isMobile;
    this.rut = rutInformation.numbers;
    this.rutControl = this.rut;
    this.serieControl = String(documentControl.value).toUpperCase();
    let idEjecutivo = form.get('txtEjecutivo').value;
    if (idEjecutivo != null && idEjecutivo !== "") {
      idEjecutivo = idEjecutivo;
    }else{
      idEjecutivo = null;
    }


    const response: GeneralResponse<any> = await this.tokenSaverService.auth(rutInformation.numbers, documentNumber, tokenCaptcha, dispositivoMobile, idEjecutivo).toPromise();
    this.respuestaAuth = response;
    if (response === null) {
      throw new Error('auth error');
    }

    if (response.indicador) {
      const loginAttemptsControl = form.get('intentos');
      loginAttemptsControl.setValue(loginAttemptsControl.value + 1);
      switch (response.indicador) {
        case AUTH_INDICATOR.IS_CLIENT:
          this.isClientDialog();
          return;
        case AUTH_INDICATOR.SS_EN_CURSO:
          this.ssEnCursoDialog(response);
          return;
        case AUTH_INDICATOR.SOLICITUD_MARCADA_COMO_AUTOATENCION:
        case AUTH_INDICATOR.EJECUTIVO_ASIGNADO_NO_COINCIDE:
        case AUTH_INDICATOR.SOLICITUD_ASIGNADA_A_EJECUTIVO:
          this.dialogService.openErrorDialog(response.mensaje.titulo, response.mensaje.contenido);
          return;
        case AUTH_INDICATOR.BLOQUEO_EJECUTIVO_PRODUCTO:
          this.dialogService.openErrorDialog("Lo sentimos", "Este producto no está habilitado para su contratación por ejecutivos");
          return;
        case AUTH_INDICATOR.UNFINISHED_TRIP_BEFORE_42_DAYS: {
          this.unfinishedTripBefore42DaysDialog();
          return;
        }

        case AUTH_INDICATOR.UNFINISHED_TRIP_AFTER_42_DAYS: {
          const dialogRef = this.dialogService.openWithoutHiringDialog();
          dialogRef.afterClosed().subscribe(() => {
            this.marketplaceRedirectService.redirect();
          });
          return;
        }

        case AUTH_INDICATOR.INTENTOS_AGOTADOS:
          // const intentosAgotados = response.mensaje.contenido.includes('se le han agotado los intentos');
          this.bloquedAccountDialog(form);
          return;

        case AUTH_INDICATOR.ERROR: {
          const intentosAgotados = response.mensaje.contenido.includes('se le han agotado los intentos');

          if (intentosAgotados) {
            this.bloquedAccountDialog(form);
          } else {
            this.validarContenido(response, form);
          }
          return;
        }
      }
    }
    const ok = await this.cantTouchThis();
    if (ok) {
      return response;
    } else {
      return null;
    }
  }

  async authPersonaNatural(form: FormGroup, isMobile: boolean): Promise<GeneralResponse<any>> {
    if (!form.valid) {
      throw new Error('form invalid');
    }
    // let continueToNextStep = false;
    const tokenCaptcha = await this.recaptcha3.getToken();

    const rut = form.get('txtRut').value;
    const telefono = form.get('txtTelefono').value;
    const correo = form.get('txtCorreo').value;
    const producto = form.get('txtProducto').value;
    const dispositivoMobile = isMobile;
    let idEjecutivo = form.get('txtEjecutivo').value;
    if (idEjecutivo != null && idEjecutivo !== "") {
      this.idEjecutivo = idEjecutivo;
    }else{
      this.idEjecutivo = null;
    }

    const rutInformation = this.rutFormatter.getRutFormats(rut);

    this.rut = rutInformation.numbers;
    this.rutControl = this.rut;

    const response: GeneralResponse<any> = await this.tokenSaverService.authLogin(rutInformation.numbers, correo, telefono, producto, tokenCaptcha, dispositivoMobile, this.idEjecutivo).toPromise();
    this.respuestaAuth = response;
    if (response === null) {
      throw new Error('auth error');
    }

    if (response.indicador) {
      const loginAttemptsControl = form.get('intentos');
      loginAttemptsControl.setValue(loginAttemptsControl.value + 1);
      switch (response.indicador) {
        case AUTH_INDICATOR.IS_CLIENT:
          this.isClientDialog();
          return;
        case AUTH_INDICATOR.SS_EN_CURSO:
          this.ssEnCursoDialog(response);
          return;
        case AUTH_INDICATOR.UNFINISHED_TRIP_BEFORE_42_DAYS: {
          this.unfinishedTripBefore42DaysDialog();
          return;
        }
        case AUTH_INDICATOR.UNFINISHED_TRIP_AFTER_42_DAYS: {
          const dialogRef = this.dialogService.openWithoutHiringDialog();
          dialogRef.afterClosed().subscribe(() => {
            this.marketplaceRedirectService.redirect();
          });
          return;
        }
        case AUTH_INDICATOR.INTENTOS_AGOTADOS:
          this.bloquedAccountDialog(form);
          return;
        case AUTH_INDICATOR.SOLICITUD_MARCADA_COMO_AUTOATENCION:
        case AUTH_INDICATOR.EJECUTIVO_ASIGNADO_NO_COINCIDE:
        case AUTH_INDICATOR.SOLICITUD_ASIGNADA_A_EJECUTIVO:
          this.dialogService.openErrorDialog(response.mensaje.titulo, response.mensaje.contenido);
          return;
        case AUTH_INDICATOR.BLOQUEO_EJECUTIVO_PRODUCTO:
          this.dialogService.openErrorDialog("Lo sentimos", "Este producto no está habilitado para su contratación por ejecutivos");
          return;
        case AUTH_INDICATOR.RETOMA_TBK_AMIGO:
          const data = {
            title: 'Contratación pendiente',
            description: 'Tienes un proceso de contratación y activación pendiente, el cual debes retomar para poder continuar',
            actionButton: 'Retomar contratación',
            icon: null
          };
          this.dialogService.openOneActionDialog({ data }).afterClosed().subscribe(() => {
            this.marketplaceRedirectService.redirectToTbkAmigo();
          });
          return;
        case AUTH_INDICATOR.ERROR: {
          const intentosAgotados = response.mensaje.contenido.includes('se le han agotado los intentos');
          if (intentosAgotados) {
            this.bloquedAccountDialog(form);
          } else {
            this.validarContenido(response, form);
          }
          return;
        }
        case AUTH_INDICATOR.FALTA_CI_RETOMA:
          this.dialogService.openCiValidationDialog(rut);
          //this.dialogService.openCiValidationDialog(rut).afterClosed().subscribe();
          return;
      }
    }

    let objReturn: any;
    if (this.hasActiveJourney(response)) {
     const ok = await this.saveAndLoadCart();
      objReturn = ok ? response : null;
    } else {
      objReturn = response;
      this.stepperService.nextStep();
    }

    return objReturn;
  }

  /**
   * Metodo de login exclusivo para Persona Jurídica
   * @param form Formulario de login de persona Juridica
   * @param isMobile Indica si se esta visitando desde un móvil
   * @returns
   */
  async authLogin(form: FormGroup, isMobile: boolean): Promise<GeneralResponse<any>> {
    const isPJ = true;
    if (!form.valid) {
      throw new Error('form invalid');
    }
    // let continueToNextStep = false;
    const tokenCaptcha = await this.recaptcha3.getToken();

    const rut = form.get('txtRut').value;
    const telefono = form.get('txtTelefono').value;
    const correo = form.get('txtCorreo').value;
    const producto = form.get('txtProducto').value;
    let idEjecutivo = form.get('txtEjecutivo').value;
    if (idEjecutivo != null && idEjecutivo !== "") {
      idEjecutivo = idEjecutivo;
    }else{
      idEjecutivo = null;
    }
    const isMarketplaceSVA = form.get('isMarketplaceSVA').value;

    const rutInformation = this.rutFormatter.getRutFormats(rut);

    this.rut = rutInformation.numbers;
    this.rutControl = this.rut;

    const response: GeneralResponse<any> = await this.tokenSaverService.authLogin(rutInformation.numbers, correo, telefono, producto, tokenCaptcha, isMobile, idEjecutivo,isMarketplaceSVA).toPromise();
    this.respuestaAuth = response;
    if (response === null) {
      throw new Error('auth error');
    }

    if (response.indicador) {
      const loginAttemptsControl = form.get('intentos');
      loginAttemptsControl.setValue(loginAttemptsControl.value + 1);
      switch (response.indicador) {
        case AUTH_INDICATOR.IS_CLIENT:
          this.isClientDialog();
          return;
        case AUTH_INDICATOR.SS_EN_CURSO:
          this.ssEnCursoDialog(response);
          return;
        case AUTH_INDICATOR.UNFINISHED_TRIP_BEFORE_42_DAYS: {
          this.unfinishedTripBefore42DaysDialog();
          return;
        }
        case AUTH_INDICATOR.UNFINISHED_TRIP_AFTER_42_DAYS: {
          const dialogRef = this.dialogService.openWithoutHiringDialog();
          dialogRef.afterClosed().subscribe(() => {
            this.marketplaceRedirectService.redirect();
          });
          return;
        }
        case AUTH_INDICATOR.INTENTOS_AGOTADOS:
          this.bloquedAccountDialog(form);
          return;
        case AUTH_INDICATOR.SOLICITUD_MARCADA_COMO_AUTOATENCION:
        case AUTH_INDICATOR.SOLICITUD_ASIGNADA_A_EJECUTIVO:
        case AUTH_INDICATOR.EJECUTIVO_ASIGNADO_NO_COINCIDE:
          this.dialogService.openErrorDialog(response.mensaje.titulo, response.mensaje.contenido);
          return;
        case AUTH_INDICATOR.BLOQUEO_EJECUTIVO_PRODUCTO:
          this.dialogService.openErrorDialog("Lo sentimos", "Este producto no está habilitado para su contratación por ejecutivos");
          return;
        case AUTH_INDICATOR.RETOMA_TBK_AMIGO:
          const data = {
            title: 'Contratación pendiente',
            description: 'Tienes un proceso de contratación y activación pendiente, el cual debes retomar para poder continuar',
            actionButton: 'Retomar contratación',
            icon: null
          };
          this.dialogService.openOneActionDialog({ data }).afterClosed().subscribe(() => {
            this.marketplaceRedirectService.redirectToTbkAmigo();
          });
          return;
        case AUTH_INDICATOR.ERROR: {
          const intentosAgotados = response.mensaje.contenido.includes('se le han agotado los intentos');
          if (intentosAgotados) {
            this.bloquedAccountDialog(form);
          } else {
            this.validarContenido(response, form);
          }
          return;
        }
        case AUTH_INDICATOR.BLOQUEO_EMPRESA_UN_DIA: {
          this.dialogService.openMaximoSocios().afterClosed();
          return response;
        }
      }
    }
    let objReturn: any;

    if (this.hasActiveJourney(response)) {
      const ok = await this.saveAndLoadCart(isPJ);
      objReturn = ok ? response : null;
    } else {
      objReturn = response;
      this.stepperService.nextStep();
    }
    return objReturn;

  }

  /**
   * Verificar si Usuario cuenta con viaje en curso
   * @param response Objeto con la respuesta desde el servicio de Login
   * @returns Verdadero si el usuario tiene un viaje en curso (SI: Solicitud de incorporacion)
   */
  private hasActiveJourney(response: any): boolean {
    return response.mensaje.contenido != AUTH_INDICATOR.EMPTY_STRING;
  }

  private async cantTouchThis(): Promise<boolean> {
    try {
      let products = [];
      const carrito = this.carroService.getCurrentProduct();
      if (carrito) {
        products = await this.productVm.obtieneSeleccionProducto().toPromise();
        this.productos = products;
        if (products.length > 0) {
          if (products[0].codigoProducto === carrito.codigoProducto) {
            this.productVm.cargarEnCarro(products);
            this.resRegProducto = await this.productoVMService.registraSeleccionProductoActual().toPromise();
          } else {
            await this.retomarContratacionDialog(products, carrito);
          }
        } else {
          this.resRegProducto = await this.productoVMService.registraSeleccionProductoActual().toPromise();
        }
      }
    } catch (exception) {
      // cant register products becose dont have products
    }
    try {
      const products2 = await this.productVm.cargaSeleccionActualEnCarro().toPromise();
      if (products2 && products2.length > 0) {
        if (this.carroService.getRetoma()) {
          const respuesta = this.dialogService.openRetomaPedido(products2[0].title);
          respuesta.afterClosed().subscribe(resp => {
            if (resp.action === 'CANCEL') {
              this.marketplaceRedirectService.redirect();
              return true;
            } else if (resp.action === 'OK') {
              this.carroService.changeRetoma(false);
              this.stepperService.nextStep();
              return true;
            }
          });
        } else {
          this.carroService.changeRetoma(false);
          if (this.respuestaAuth.mensaje.contenido === '3' && _.get(this.resRegProducto, 'data', '3') === '3') {
            // this.router.navigate(['/'], { queryParams: { action: AUTH_INDICATOR.IS_RETOMA } });
            await this.verificarPaso();
          } else {
            this.stepperService.nextStep();
            return true;
          }
        }
      } else {
        if (this.carroService.getRetoma()) {
          const respuesta = this.dialogService.openContratacionNoIniciada();
          respuesta.afterClosed().subscribe((resp) => {
            this.marketplaceRedirectService.redirect();
          });
          return false;
        } else {
          const respuesta = this.dialogService.openSolicitudVacia();
          this.carroService.changeRetoma(false);
          this.carroService.carroCompraVacio = false;
          respuesta.afterClosed().subscribe((resp) => {
            this.marketplaceRedirectService.redirect();
          });
          return false;
        }
      }
    } catch (exception) {
      const respuesta = this.dialogService.openErrorDialog('Lo sentimos', 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, intenta más tarde.');
      respuesta.afterClosed().subscribe((resp) => {
        return;
      });
      return false;
    }

    // TODO for bypass step one => this.stepperService.nextStep();
  }

  private async saveAndLoadCart(isPJ: boolean = false): Promise<boolean> {
    try {
      let products = [];
      const carrito = this.carroService.getCurrentProduct();
      if (carrito) {
        products = await this.productVm.obtieneSeleccionProducto().toPromise();
        this.productos = products;
        if (products.length > 0) {
          if (products[0].codigoProducto === carrito.codigoProducto) {
            this.productVm.cargarEnCarro(products);
            this.resRegProducto = await this.productoVMService.registraSeleccionProductoActual().toPromise();
          } else {
            // Cuadro de dialogo que indica si cliente quiere retomar contratación o no
            await this.retomarContratacionDialog(products, carrito);
          }
        } else {
          this.resRegProducto = await this.productoVMService.registraSeleccionProductoActual().toPromise();
        }
      }
    } catch (exception) {
      console.error('Cant register products because dont have products');
    }
    // Despues de confirmacion de producto
    try {
      const products2 = await this.productVm.cargaSeleccionActualEnCarro().toPromise();
      if (products2 && products2.length > 0) {
        if (this.carroService.getRetoma()) {
          const respuesta = this.dialogService.openRetomaPedido(products2[0].title);
          respuesta.afterClosed().subscribe(resp => {
            if (resp.action === 'CANCEL') {
              this.marketplaceRedirectService.redirect();
              return true;
            } else if (resp.action === 'OK') {
              this.carroService.changeRetoma(false);
              this.stepperService.nextStep();
              return true;
            }
          });
        } else {
          this.carroService.changeRetoma(false);
          if (this.respuestaAuth.mensaje.contenido === '3' && _.get(this.resRegProducto, 'data', '3') === '3' && !isPJ) {
            if (this.idEjecutivo === null) {
              this.router.navigate(['/'], { queryParams: { action: AUTH_INDICATOR.IS_RETOMA } });
            } else {
              this.router.navigate(['/'], { queryParams: { action: AUTH_INDICATOR.IS_RETOMA, idEjecutivo: this.idEjecutivo } });
            }
          } else if ((this.respuestaAuth.mensaje.contenido === '3' || this.respuestaAuth.mensaje.contenido === '4') &&
                      (_.get(this.resRegProducto, 'data', '3') === '3' || _.get(this.resRegProducto, 'data', '3') === '4') &&
                      isPJ
                    ) {
                      await this.verificarPaso();
                    } else {
                      this.stepperService.nextStep();
                      return true;
                    }
        }
      } else {
        if (this.carroService.getRetoma()) {
          const respuesta = this.dialogService.openContratacionNoIniciada();
          respuesta.afterClosed().subscribe((resp) => {
            this.marketplaceRedirectService.redirect();
          });
          return false;
        } else {
          const respuesta = this.dialogService.openSolicitudVacia();
          this.carroService.changeRetoma(false);
          this.carroService.carroCompraVacio = false;
          respuesta.afterClosed().subscribe((resp) => {
            this.marketplaceRedirectService.redirect();
          });
          return false;
        }
      }
    } catch (exception) {
      const respuesta = this.dialogService.openErrorDialog('Lo sentimos', 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, intenta más tarde.');
      respuesta.afterClosed().subscribe((resp) => {
        return;
      });
      return false;
    }

    // TODO for bypass step one => this.stepperService.nextStep();
  }

  private async verificarPaso() {
    const resp = await this.goToPaso3Service.goToPaso3();

    if (this.rutControl >= 50000000) {
      this.isPersonaNatural = false;
    } else {
      this.isPersonaNatural = true;
    }

    if (resp === 'GOTO_PASO_3') {
      if (this.isPersonaNatural) {
        const paso_1: Paso1 = {
          run: this.rutControl,
          ci: this.serieControl,
          currentIsPersonaNatural: this.isPersonaNatural
        };
        this.storage.setPaso1(paso_1);
      }
      this.stepperService.nextStep();
      this.stepperService.nextStep();
    }
  }

  private async retomarContratacionDialog(products: any[], carrito: Product) {
    const data = {
      title: '¿Cómo te gustaría continuar?',
      description: '<strong>Habías comenzado</strong> un proceso de contratación de: <strong>' + products[0].title + '</strong>.<br>' +
        'Para terminar con el proceso que iniciaste selecciona <strong>"Retomar contratación</strong>".<br><br>' +
        'Si deseas continuar con el producto que seleccionaste: <strong>' + carrito.title + '</strong> puedes seguir con la nueva solicitud ' +
        'seleccionando <strong>"Iniciar nueva solicitud"</strong>.',
      actionButton: 'Nueva solicitud',
      cancelButton: 'Retomar contratación',
      deleteAction: false,
      productTitle: null
    };
    const resp = await this.dialogService.openTwoActionsDialog({ data }).afterClosed().toPromise();
    if (resp.action === 'OK') {
      try {
        this.resRegProducto = await this.productoVMService.registraSeleccionProductoActual().toPromise();
        //
        if (this.resRegProducto.indicador === 'ERROR_PRODUCTO_CAMBIO_RECHAZADO') {
          // await this.retomarContratacionProductoActual(products);
          await this.dialogService.openCambioProductoRechazado(this.productos[0].title).afterClosed().toPromise();
          this.retomarContratacionProductoActual(products);
        }
      } catch (error) {
        if (error.error.indicador === 'ERROR_PRODUCTO_CAMBIO_RECHAZADO') {
          // await this.retomarContratacionProductoActual(products);
          await this.dialogService.openCambioProductoRechazado(this.productos[0].title).afterClosed().toPromise();
          this.retomarContratacionProductoActual(products);
        }
      }
    } else if (resp.action === 'CANCEL') {
      this.productVm.cargarEnCarro(products);
      this.carroService.changeRetoma(true);
      //await this.productoVMService.registraSeleccionProductoActual().toPromise();
      this.carroService.changeRetoma(false);
      /*await this.productoVMService.cargaSeleccionActualEnCarro().toPromise();*/
    }
  }

  private async retomarContratacionProductoActual(products: any[]) {
    this.productVm.cargarEnCarro(products);
    this.carroService.changeRetoma(true);
    await this.productoVMService.registraSeleccionProductoActual().toPromise();
    this.carroService.changeRetoma(false);
  }

  private async modalRetomar(resp: DialogResult, products: any[]) {
    if (resp.action === 'CANCEL') {
      await this.productoVMService.registraSeleccionProductoActual().toPromise();
    } else if (resp.action === 'OK') {
      this.productVm.cargarEnCarro(products);
      this.carroService.changeRetoma(true);
      await this.productoVMService.registraSeleccionProductoActual().toPromise();
      this.carroService.changeRetoma(false);
      // await this.productoVMService.cargaSeleccionActualEnCarro().toPromise();
    }
  }

  createForm(): FormGroup {
    return this.formBuilder.group({
      intentos: new FormControl(0),
      txtRut: new FormControl('', [
        Validators.required,
        rutValidator
      ]),
      txtSerie: new FormControl('', [
        Validators.required,
        serieValidator
      ]),
      txtEjecutivo: new FormControl(),
      autorizacion: new FormControl('', [Validators.requiredTrue]),
      autorizacion2: new FormControl('', [Validators.requiredTrue])
    });
  }

  createSocioCIForm(): FormGroup {
    return this.formBuilder.group({
      intentos: new FormControl(0),
      txtRut: new FormControl('', [
        Validators.required,
        rutValidator
      ]),
      txtSerie: new FormControl('', [
        Validators.required,
        serieValidator
      ])
    });
  }

  createLoginForm(): FormGroup {
    return this.formBuilder.group({
      intentos: new FormControl(0),
      txtRut: new FormControl('', [
        Validators.required,
        rutValidator
      ]),
      txtCorreo: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{1,}(\-?\.?\_?[a-zA-Z0-9])*@[a-zA-Z0-9_\-\.~]{1,}\.[a-zA-Z]{2,4}$/)
      ]),
      txtTelefono: new FormControl('', [
        Validators.required,
        lengthValidator(9, 9),
        Validators.pattern('^[1-9][0-9]*')
      ]),
      txtProducto: new FormControl(''),
      txtEjecutivo: new FormControl()
    });
  }

  // TODO: Eliminar al finalizar desarrollo de Login Unificado
  createLoginEmpresaForm(): FormGroup {
    return this.formBuilder.group({
      intentos: new FormControl(0),
      txtRut: new FormControl('', [
        Validators.required,
        rutEmpresaValidator
      ]),
      txtCorreo: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{1,}(\-?\.?\_?[a-zA-Z0-9])*@[a-zA-Z0-9_\-\.~]{1,}\.[a-zA-Z]{2,4}$/)
      ]),
      txtTelefono: new FormControl('', [
        Validators.required,
        lengthValidator(9, 9),
        Validators.pattern('^[1-9][0-9]*')
      ]),
      txtProducto: new FormControl(''),
      txtEjecutivo: new FormControl(''),
      autorizacion: new FormControl('', [Validators.requiredTrue]),
      autorizacion2: new FormControl('', [Validators.requiredTrue]),
      isMarketplaceSVA: new FormControl()
    });
  }

  createLoginUnificadoForm(): FormGroup {
    return this.formBuilder.group({
      intentos: new FormControl(0),
      txtRut: new FormControl('', [
        Validators.required,
        rutGenericoValidator
      ]),
      txtCorreo: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{1,}(\-?\.?\_?[a-zA-Z0-9])*@[a-zA-Z0-9_\-\.~]{1,}\.[a-zA-Z]{2,4}$/)
      ]),
      txtCorreoConfirm: new FormControl('', [Validators.required]),
      txtTelefono: new FormControl('', [
        Validators.required,
        lengthValidator(9, 9),
        Validators.pattern('^[1-9][0-9]*')
      ]),
      txtProducto: new FormControl(''),
      txtEjecutivo: new FormControl(''),
      autorizacion: new FormControl('', [Validators.requiredTrue]),
      autorizacion2: new FormControl('', [Validators.requiredTrue]),
      isMarketplaceSVA: new FormControl()
    });
  }

  initCaptcha(): Promise<unknown> {
    return this.recaptcha3.init(environment.captchakey);
  }

  isClientDialog(): void {
    const dialogRef = this.dialogService.openTbkClientDialog();
    dialogRef.afterClosed().subscribe((result: DialogResult) => {
      this.marketplaceRedirectService.redirectToPortalPrivado();
    });
  }

  ssEnCursoDialog(response: GeneralResponse<any>): void {
    this.dialogService.openRequestInProgressDialog(response.data);
  }

  unfinishedTripBefore42DaysDialog(): void {
    const dialogRef = this.dialogService.openResumeHiringDialog();
    dialogRef.afterClosed().subscribe((result: ResumeHiringDialogResult) => {
      if (result) {
        switch (result.action) {
          case RESUME_HIRING_ACTIONS.PRIMARY:
            this.marketplaceRedirectService.redirect();
            break;

          case RESUME_HIRING_ACTIONS.SECONDARY:
            this.stepperService.nextStep();
            break;
          default:
            this.marketplaceRedirectService.redirect();
        }
      }
    });
  }

  bloquedAccountDialog(form: FormGroup): void {
    form.get('txtSerie').setErrors({
      invalidSerieOfRut: true
    });

    const dialogRef = this.dialogService.openAccountBloquedDialog();
    dialogRef.afterClosed().subscribe((result: DialogResult) => {
      if (result && result.action) {
        this.marketplaceRedirectService.redirectWithProducts();
      }
    });
  }

  validarContenido(response: GeneralResponse<any>, form: FormGroup): void {
    // const loginAttemptsControl = form.get('intentos');
    const loginAttempts = response.data;
    switch (response.mensaje.contenido) {
      case ContenidoEnum.NO_VIGENTE:
      case ContenidoEnum.SERIE_NO_COINCIDE:
        form.get('txtSerie').setErrors({
          invalidSerieOfRut: true
        });
        if (loginAttempts === 2) {
          this.dialogService.openInvalidSerieOfRutFirstAttemptDialog();
        } else if (loginAttempts === 1) {
          this.dialogService.openInvalidSerieOfRutSecondAttemptDialog();
        }
        break;

      default:
        const dialogRef = this.dialogService.openErrorDialog(response.mensaje.titulo, response.mensaje.contenido);
        dialogRef.afterClosed().subscribe((result: DialogResult) => {
          return false;
        });
    }
  }
}
